const homeSliderImages = [
  {
    id: 'home-slide-1',
    src: './home-slider/home-slider-01.webp',
    alt: '至善 30 首頁輪播圖片 1',
  },
  {
    id: 'home-slide-2',
    src: './home-slider/home-slider-02.webp',
    alt: '至善 30 首頁輪播圖片 2',
  },
  {
    id: 'home-slide-3',
    src: './home-slider/home-slider-03.webp',
    alt: '至善 30 首頁輪播圖片 3',
  },
  {
    id: 'home-slide-4',
    src: './home-slider/home-slider-04.webp',
    alt: '至善 30 首頁輪播圖片 4',
  },
  {
    id: 'home-slide-5',
    src: './home-slider/home-slider-05.webp',
    alt: '至善 30 首頁輪播圖片 5',
  },
];

export default homeSliderImages;
